/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Feature_Diet_TitleInputs */

const en_platform_feature_diet_title = /** @type {(inputs: Platform_Feature_Diet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diet plans`)
};

const pl_platform_feature_diet_title = /** @type {(inputs: Platform_Feature_Diet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plany diety`)
};

/**
* | output |
* | --- |
* | "Diet plans" |
*
* @param {Platform_Feature_Diet_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_feature_diet_title = /** @type {((inputs?: Platform_Feature_Diet_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Feature_Diet_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_feature_diet_title(inputs)
	return en_platform_feature_diet_title(inputs)
});